/* eslint-disable */

import axios from 'axios'
const axiosinstance = axios.create()
axiosinstance.interceptors.request.use(
    function (config) {
        config.baseURL = window['APIhost']
        config.withCredentials = false
        config.crossDomain = true
        config.headers['Content-Type'] = 'application/json'
        config.headers['X-ApiKey'] = localStorage.getItem('apiKey')
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

export default {
    get (url, request) {
        return axiosinstance.get(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    post (url, request) {
        return axiosinstance.post(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    patch (url, request) {
        return axiosinstance.patch(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    delete (url, request) {
        return axiosinstance.delete(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    }
}
